import {
  goodsList,
  createGoods,
  modifyGoods,
  deleteGoods,
  auditReq,
  optShelt,
  goodsCategoryOption,
  goodStateList,
  queryMemberDayTimeList,
  orderStatistics,
  queryMemberDayTimeDetailList,
  queryWeekDayList,
  addMemberDayTime,
  updateMemberDayTime,
  deleteMemberDayDetail,
  changeGoodsOrd
} from '@/api/sys.goods'

export default {
  namespaced: true,
  actions: {
    /**
         * 分页查询
         */
    goodsList ({
      dispatch
    }, {
      vm,
      data
    }) {
      return goodsList(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    createGoods ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求
      return createGoods(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    modifyGoods ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求
      return modifyGoods(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    deleteGoods ({
      dispatch
    }, {
      vm,
      data
    }) {
      return deleteGoods(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    auditReq ({
      dispatch
    }, {
      vm,
      data
    }) {
      return auditReq(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    optShelt ({
      dispatch
    }, {
      vm,
      data
    }) {
      return optShelt(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    goodsCategoryOption ({
      dispatch
    }) {
      return goodsCategoryOption()
        .then(res => {
          return res
        })
        .catch(err => {
          console.log('err: ', err)
        })
    },
    goodStateList ({
      dispatch
    }, {
      vm,
      data
    }) {
      return goodStateList(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    queryMemberDayTimeList ({
      dispatch
    }, {
      vm
    }) {
      return queryMemberDayTimeList()
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    orderStatistics ({
      dispatch
    }, {
      vm,
      data
    }) {
      return orderStatistics(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    queryMemberDayTimeDetailList ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryMemberDayTimeDetailList(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    queryWeekDayList ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryWeekDayList(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    addMemberDayTime ({
      dispatch
    }, {
      vm,
      data
    }) {
      return addMemberDayTime(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    updateMemberDayTime ({
      dispatch
    }, {
      vm,
      data
    }) {
      return updateMemberDayTime(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    deleteMemberDayDetail ({
      dispatch
    }, {
      vm,
      data
    }) {
      return deleteMemberDayDetail(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    changeGoodsOrd ({
      dispatch
    }, {
      vm,
      data
    }) {
      return changeGoodsOrd(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    }

  }
}
